module.exports = __webpack_public_path__ + "static/media/TapCharacter.9164b580.jpg";